var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('applicationForm',{attrs:{"eventStatusId":_vm.eventStatusId,"eventStatusDetail":_vm.eventStatusDetail,"formType":_vm.formType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }